class ProductDescription extends Component {
    constructor(el) {
        super(el);
        this.text = this.$find('[data-text-overflow]');
        this.btnShow = this.$find('[data-button-show]');
        this.btnHide = this.$find('[data-button-hide]');
        this.addEventListeners();
    }

    hideText() {
        this.text.classList.remove('is-open');
        this.btnShow.classList.remove('u-hidden');
        this.btnHide.classList.add('u-hidden');
    }

    showText() {
        this.text.classList.add('is-open');
        this.btnShow.classList.add('u-hidden');
        this.btnHide.classList.remove('u-hidden');
    }

    addEventListeners() {
        this.btnShow.addEventListener('click', e => { this.showText() });
        this.btnHide.addEventListener('click', e => { this.hideText() });
    }
}